const sectionItemsGrid04Css = `
[data-type='section-items-grid-04'] .items-grid-wrapper {
  background-color: var(--background-color, #f2f2f2);
}

[data-type='section-items-grid-04'] .items-grid-wrapper[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-items-grid-04'] .items-grid-wrapper[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-items-grid-04'] .items-grid-wrapper[data-show-number='false'] .items-grid-item-number {
  display: none;
}

[data-type='section-items-grid-04'] .items-grid-wrapper[data-image-show='false'] .items-grid-list-wrapper {
  grid-template-columns: 1fr;
}

[data-type='section-items-grid-04'] .items-grid-wrapper[data-image-show='false'] .items-grid-list-image {
  display: none;
}

[data-type='section-items-grid-04'] .items-grid-wrapper[data-image-position='right'] .items-grid-list-image {
  order: 2;
}

[data-type='section-items-grid-04'] .items-grid-wrapper[data-image-position='right'] .items-grid-list {
  order: 1;
}

[data-type='section-items-grid-04'] .items-grid-wrapper[data-image-position='left'] .items-grid-list-image {
  order: 1;
}

[data-type='section-items-grid-04'] .items-grid-wrapper[data-image-position='left'] .items-grid-list {
  order: 2;
}

[data-type='section-items-grid-04'] .items-grid-content {
  padding-inline: 8px;
}

[data-type='section-items-grid-04'] .items-grid-header:not(:empty) {
  margin-bottom: 32px;
}

[data-type='section-items-grid-04'] .items-grid-header h1,
[data-type='section-items-grid-04'] .items-grid-header h2,
[data-type='section-items-grid-04'] .items-grid-header h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
  color: var(--text-color, #000000);
}

[data-type='section-items-grid-04'] .items-grid-header h1:last-child,
[data-type='section-items-grid-04'] .items-grid-header h2:last-child,
[data-type='section-items-grid-04'] .items-grid-header h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-items-grid-04'] .items-grid-header p {
  font-size: 18px;
  margin: 0 0 8px 0 !important;
  line-height: normal;
  color: var(--text-color, #000000);
}

[data-type='section-items-grid-04'] .items-grid-header p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-items-grid-04'] .items-grid-header figure {
  overflow-x: auto;
  overflow-y: hidden;
}

[data-type='section-items-grid-04'] .items-grid-list-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 16px;
  max-width: var(--items-grid-list-width, 85%);
  margin: 0 auto;
}

[data-type='section-items-grid-04'] .items-grid-list-image {
  width: 100%;
  height: fit-content;
  order: 1;
}

[data-type='section-items-grid-04'] .items-grid-list-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-items-grid-04'] .items-grid-list {
  --items-gap: 16px;
  order: 2;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: var(--items-gap);
}

[data-type='section-items-grid-04'] .items-grid-item {
  --item-basis-desktop: calc(
    (100% - (var(--items-per-row-desktop, 1) - 1) * var(--items-gap)) / var(--items-per-row-desktop, 1)
  );
  --item-basis-mobile: calc(
    (100% - (var(--items-per-row-mobile, 1) - 1) * var(--items-gap)) / var(--items-per-row-mobile, 1)
  );

  flex: 0 0 var(--item-basis-desktop);
  max-width: var(--item-basis-desktop);

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  border-radius: var(--card-border-radius, 12px);
  padding: 10px;
  background-color: var(--card-background-color, #14a16c);
}

[data-type='section-items-grid-04'] .items-grid-item-number {
  font-size: 18px;
  font-weight: 700 !important;
  color: var(--card-text-color, #ffffff);
  height: 100%;
}

[data-type='section-items-grid-04'] .items-grid-item-image {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--card-background-color, #14a16c);
  border-radius: 4px;
  max-width: var(--item-image-width-desktop, 110px);
  max-height: var(--item-image-width-desktop, 110px);
  width: 100%;
  height: fit-content;
}

[data-type='section-items-grid-04'] .items-grid-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-items-grid-04'] .items-grid-item-text {
  flex: 1;
}

[data-type='section-items-grid-04'] .items-grid-item-text h1,
[data-type='section-items-grid-04'] .items-grid-item-text h2,
[data-type='section-items-grid-04'] .items-grid-item-text h3 {
  font-size: 20px;
  line-height: normal;
  margin: 0 0 10px 0 !important;
  color: var(--card-text-color, #ffffff);
}

[data-type='section-items-grid-04'] .items-grid-item-text h1:last-child,
[data-type='section-items-grid-04'] .items-grid-item-text h2:last-child,
[data-type='section-items-grid-04'] .items-grid-item-text h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-items-grid-04'] .items-grid-item-text p {
  font-size: 16px;
  margin: 0 0 6px 0 !important;
  line-height: normal;
  color: var(--card-text-color, #ffffff);
}

[data-type='section-items-grid-04'] .items-grid-item-text p:last-child {
  margin-bottom: 0 !important;
}

@container (max-width: 768px) {
  [data-type='section-items-grid-04'] .items-grid-wrapper[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-items-grid-04'] .items-grid-wrapper[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-items-grid-04'] .items-grid-header:not(:empty) {
    margin-bottom: 24px;
  }

  [data-type='section-items-grid-04'] .items-grid-header h1,
  [data-type='section-items-grid-04'] .items-grid-header h2,
  [data-type='section-items-grid-04'] .items-grid-header h3 {
    font-size: 20px;
  }

  [data-type='section-items-grid-04'] .items-grid-header p {
    font-size: 14px;
  }

  [data-type='section-items-grid-04'] .items-grid-header figure {
    width: 98% !important;
  }

  [data-type='section-items-grid-04'] .items-grid-list-wrapper {
    max-width: 100%;
    grid-template-columns: 1fr;
  }

  [data-type='section-items-grid-04'] .items-grid-item {
    flex-basis: var(--item-basis-mobile);
    max-width: var(--item-basis-mobile);
    flex-direction: column;
  }

  [data-type='section-items-grid-04'] .items-grid-item-image {
    max-width: var(--item-image-width-mobile, 110px);
    max-height: var(--item-image-width-mobile, 110px);
  }

  [data-type='section-items-grid-04'] .items-grid-item-text h1,
  [data-type='section-items-grid-04'] .items-grid-item-text h2,
  [data-type='section-items-grid-04'] .items-grid-item-text h3 {
    text-align: center;
    font-size: 18px;
  }

  [data-type='section-items-grid-04'] .items-grid-item-text p {
    text-align: center;
  }
}
`;
export default sectionItemsGrid04Css;
